/**
 * @format
 * sort-imports-ignore
 */
import { initAppModule } from './app/angularApp';
import { enableProdMode, StaticProvider, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { downgradeModule } from '@angular/upgrade/static';
import { enableAkitaProdMode } from '@datorama/akita';
import * as angular from 'angular';
import { initAngular, initUIRouter } from 'sis-common';
import './student-import';
import { downgradedComponents, downgradedServices } from './app/ajs-downgraded-modules';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
    enableAkitaProdMode();
}

// Note: the argument to bootstrapModule() must be a direct reference to AppModule (and not a variable),
// so that the Ahead-of-Time compiler can find it with static analysis
const bootstrapFn = (extraProviders: StaticProvider[]) =>
    platformBrowserDynamic(extraProviders)
        .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
        .then(initUIRouter);
const downgradedModuleName = downgradeModule(bootstrapFn);

initAngular(downgradedComponents, downgradedServices);
const appModule = initAppModule([downgradedModuleName]);
angular.bootstrap(document, [appModule.name]);
